export default __webpack_public_path__ + "static/media/logo.b194170c.png";